module.exports = __webpack_public_path__ + "img/ch18_07_天台灯火.d89f932c.jpg";